"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//__SERVICES
const ManagementPracticesService_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/services/ManagementPracticesService"));
const CropsService_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/services/CropsService"));
const ProvidersService_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/services/ProvidersService"));
//__MODELS
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
//__STEPS
const WorkflowStep_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/WorkflowStep"));
const FilesSummaryStep_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/FilesSummaryStep"));
const FieldsPreviewTable_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/FieldsPreviewTable"));
const FieldsSummaryStep_1 = __importDefault(require("@becrop/components/FieldsSetupFlow/modules/models/FieldsSummaryStep"));
const ProvidersStep_1 = __importDefault(require("../models/ProvidersStep"));
const VardaStepModel_1 = __importDefault(require("../models/Steps/VardaStepModel"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const CROPS_SERVICE = new CropsService_1.default();
const MANAGEMENT_PRACTICES_SERVICE = new ManagementPracticesService_1.default();
const PROVIDERS_SERVICE = new ProvidersService_1.default();
const workflows = ['#gis_files', '#draw_select', '#external_providers'];
const workflowStepDefault = new WorkflowStep_1.default({ id: '#workflow', data: { currentWorkflow: '', workflows: workflows } });
const filesSummaryStepDefault = new FilesSummaryStep_1.default({ id: '#files_summary', data: { files: [], fieldsProcessed: [] } });
const fieldsPreviewTableStepDefault = new FieldsPreviewTable_1.default({ id: '#fields_preview_table', data: { fields: [], selectedFields: [] } });
const fieldsSummaryStepDefault = new FieldsSummaryStep_1.default({ id: '#fields_summary', data: { fields: [] } });
const providerStepDefault = new ProvidersStep_1.default({ id: '#providers_step', data: { fields: [], selectedFields: [] } });
const vardaStepDefault = new VardaStepModel_1.default({ id: '#varda_step', data: { fields: [], selectedFields: [] } });
class FieldsSetupFlowController {
    constructor() {
        this._currentStep = workflowStepDefault;
        this.selectedPrjCode = 'EPSG: 4326';
        this.crops = [];
        this.providers = [];
        this.managementPractices = [];
        this.workflowStep = workflowStepDefault;
        this.filesSummaryStep = filesSummaryStepDefault;
        this.fieldsPreviewTableStep = fieldsPreviewTableStepDefault;
        this.fieldsSummaryStep = fieldsSummaryStepDefault;
        this.providersStep = providerStepDefault;
        this.vardaStep = vardaStepDefault;
        this.userCurrentCrop = null;
        this.farmToAddFields = '';
        this.crop = new Crop_1.default({});
        this.editFarmGeodata = '';
    }
    static getInstance() {
        if (this._instance)
            return this._instance;
        this._instance = new FieldsSetupFlowController();
        return this._instance;
    }
    async fetchCrops() {
        await CROPS_SERVICE.fetchCrops();
        CROPS_SERVICE.data.forEach(crop => this.crops.push(crop));
    }
    async fetchManagementPractices() {
        await MANAGEMENT_PRACTICES_SERVICE.fetchManagementPractices();
        MANAGEMENT_PRACTICES_SERVICE.data.forEach(practice => this.managementPractices.push(practice));
    }
    async fetchProviders() {
        await PROVIDERS_SERVICE.fetchProviders();
        PROVIDERS_SERVICE.data.forEach(provider => this.providers.push(provider));
    }
    get currentStep() {
        return this._currentStep;
    }
    get projections() {
        return ['EPSG:4326', 'EPSG:3857', 'EPSG:102642'];
    }
    get steps() {
        return [this.workflowStep, this.filesSummaryStep, this.fieldsPreviewTableStep, this.fieldsSummaryStep, this.providersStep, this.vardaStep];
    }
    setCurrentStep(step) {
        this._currentStep = step;
    }
    setPrjCode(newPrjCode) {
        this.selectedPrjCode = newPrjCode;
    }
    setUserCurrentCrop(cropId) {
        if (this.crops.length > 0) {
            this.userCurrentCrop = this.crops.find((crop) => crop.id === cropId);
        }
        else {
            console.warn('The list of crops is empty');
        }
    }
    get isAddingFields() {
        const myFarmId = this.farmIdToAddFieldsTo;
        return (myFarmId) ? true : false;
    }
    get farmIdToAddFieldsTo() {
        const params = new URLSearchParams(window.location.search);
        let farmId = params.get('farm_id');
        return farmId;
    }
    setFarmToAddFields(farm) {
        this.farmToAddFields = farm;
    }
    setCropToAddFields(cropId) {
        const crop = this.crops.find((c) => c.id === cropId);
        if (crop) {
            this.crop = crop;
        }
    }
    setFarmGeodata(geodata) {
        this.editFarmGeodata = geodata.length > 0
            ? `MULTIPOLYGON(${geodata.map(wkt => {
                const match = wkt.match(/\(\(.*\)\)/);
                if (match) {
                    return match[0].slice(1, -1);
                }
                return "";
            }).filter(coords => coords !== "").join(",")})`
            : "MULTIPOLYGON(())";
    }
    get parseGeodataToCoordinates() {
        const match = this.editFarmGeodata.match(/\(\((-?[0-9.]+) (-?[0-9.]+)/);
        if (!match)
            throw new Error('Invalid geodata format');
        return [parseFloat(match[1]), parseFloat(match[2])];
    }
    logActivity(eventObj) {
        const controller = new EventTracker_1.default();
        controller.trackEvent(eventObj.name, eventObj.props);
    }
}
exports.default = FieldsSetupFlowController;
